export function sortcities (cities) {
  let citiesSort = []
  cities.content.map(item => {

    citiesSort.push({   'label': item.nome + ' - ' + item.estado.sigla,
                        'nome': item.nome,
                        'estado' : item.estado.nome,
                        'ibge' : item.codigo
                      })
  });
  return citiesSort.sort((a, b) => (a.nome > b.nome) ? 1 : -1)
}
